/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
// React


import { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

// Libraries
import toast, { Toaster } from 'react-hot-toast';
import Select from 'react-select';
import Moment from 'react-moment';
import moment from "moment";
import 'moment/locale/pt-br';
import DateTimePicker from 'react-datetime-picker';
import { Oval } from 'react-loader-spinner';

// Services
import axios from "axios";
import api from "../../services/api";
import { useAuth } from "../../contexts/UserContext";

// Icons
import {
    IconClock,
    IconClose,
    IconDownload,
    IconEdit,
    IconFile,
    IconServiceValue,
    IconThreeDots,
    IconThreeDotsH,
    IconTimer,
    IconUser,
    IconStatus,
    IconSearch,
    IconDeleteOne,
    IconDeleteTwo,
    IconFloppyDisk,
    IconPlus,
    IconWarning,
    IconTrash,
    IconUpload,
    IconAccept,
    IconDuplicate,
    IconCheckedRed,
    IconFinish,
} from "../../components/icons";

//  Components
import ButtonIcon from "../../components/form/ButtonIcon";
import ModalDefault from "../../components/ModalDefault";
import ButtonDefault from "../../components/form/ButtonDefault";
import InputDefault from "../../components/form/InputDefault";
import OfficeSelector, { Office } from "../../components/OfficeSelector";
import { ModalityAudience } from "../../components/Data/ModalityAudience";
import { ModalcontactMain } from "../../components/SearchProfessionalProposal/styles";
import InputMoney from "../../components/form/InputMoney";

//  Data
import { LaborHearing } from "../../components/Data/LaborHearing";
import { CivilHearing } from "../../components/Data/CivilHearing";
import { CriminalHearing } from "../../components/Data/CriminalHearing";
import { EstadosBrasileiros } from "../../components/Data/StatesData";
import { ProfessionalTypeNecessary } from "../../components/Data/ProfessionalTypeNecessary";

//  Styles
import {
    Buttons,
    Container,
    DeadlineInfos,
    DropDownMenu,
    Files,
    HistoryTitle,
    ModalButtons,
    ModalChanges,
    ModalContactHead,
    ModalJustification,
    ModalSearch,
    ModalTitle,
    ModalWrapper,
    Orientations,
    ProposalAdress,
    ProposalDetails,
    ProposalInfos,
    ProposalLeft,
    ServiceTags,
    ServiceValue,
    Status,
    StatusHeader
} from "./styles";
import {clarity} from "react-microsoft-clarity";
import { comum } from "../../styles/Themes/light";
import { toastDefs, toastDefsError } from '../../config/toastConfig';
import BlocoEnderecoProposta from "../../components/Proposta/BlocoEnderecoProposta";
import ProfessionalSelector from "../../components/ProfessionalSelector";
import { TimelineProposta } from "../../components/Proposta/TimelineProposta";
import BlocoPendencias from "../../components/Pendencias/BlocoPendencias";

interface ProposalProps {
    id_usuario: any,
    id_servico: any,
    id_comarca: any,
    tags: any,
    arquivos: any,
    numero_processo: string,
    nome_cliente: any,
    valor_cliente: string,
    codigo_cliente: string,
    prazo_aceite: string,
    prazo_para_conclusao: string,
    dias_uteis_para_conclusao: string,
    orientacoes: string,
    tipo_audiencia: string,
    data: any,
    profissional_necessario: string,
    modalidade: string,
    endereco_virtual: string,
    rua: string,
    bairro: string,
    cep: string,
    numero: string,
    complemento: string,
    valor_profissional?: any,
    lucro?: any,
    lucro_porcentagem?: any,
}

export default function Proposal() {
    const MAX_TAG_LENGTH = 200;
    const { setPageName, user, setPageType } = useAuth();
    const params = useParams<any>();
    const proposalId = params.id;
    const history = useHistory();
    const historyRef = useRef<any>();
    const menuRef = useRef<any>();
    const [ loading, setLoading ] = useState<any>(false);
    
    // Obter a URL base da API
    const baseURL = api.defaults.baseURL;
    
    // Helper function to encode file paths for URLs
    // Encodes special characters but preserves forward slashes
    const encodeFilePath = (filePath: string) => {
        return filePath.split('/').map(segment => encodeURIComponent(segment)).join('/');
    };

    // Helper function to normalize file path - adds id_proposta if path doesn't have folder
    const normalizeFilePath = (caminho: string, idProposta: number | null | undefined): string => {
        if (!caminho || caminho.trim() === '') {
            return caminho;
        }
        
        // Se o caminho já tem pasta (contém '/'), retorna como está
        if (caminho.includes('/')) {
            return caminho;
        }
        
        // Se não tem pasta e tem id_proposta, adiciona antes
        if (idProposta) {
            return `${idProposta}/${caminho}`;
        }
        
        return caminho;
    };
    
    const [ proposalInitial, setProposalInitial ] = useState<any>();
    const [ professional, setProfessional ] = useState<any>();
    const [ modalContact, setModalContact ] = useState<any>();
    const [ openHistory, setOpenHistory ] = useState<any>();
    const [ DTOSearch, setDTOSearch ] = useState<any>();
    const [ openMenu, setOpenMenu ] = useState<any>();
    const [ deleteProposal, setDeleteProposal ] = useState<any>();
    const [ justicationText, setJustificationText ] = useState<any>();
    const [ secondStage, setSecondStage ] = useState<any>();
    const [ editProposal, setEditProposal ] = useState<any>();
    const [ counties, setCounties ] = useState<any>();
    const [ cepCounty, setCepCounty ] = useState<any>();
    const [ cepAddress, setCepAddress ] = useState<any>();
    const [ selectedOffice, setSelectedOffice ] = useState<Office>({
        nome: '',
        id_escritorio_solicitante: 0,
        codigo: 0,
    });
    const [ DTOProposal, setDTOProposal ] = useState<any>({
        id_usuario: '',
        id_servico: '',
        id_comarca: '',
        tags: '',
        arquivos: '',
        numero_processo: '',
        nome_cliente: '',
        codigo_cliente: '',
        prazo_aceite: '',
        prazo_para_conclusao: '',
        dias_uteis_para_conclusao: "",
        orientacoes: '',
        tipo_audiencia: '',
        data: '',
        profissional_necessario: '',
        modalidade: '',
        endereco_virtual: '',
        rua: cepAddress,
        bairro: cepCounty,
        cep: '',
        numero: '',
        complemento: '',
        valor_profissional: '',
        valor_cliente: '',
    });
    const [ dateHearing, setDateHearing ] = useState<any>();
    const [ datePickerKey, setDatePickerKey ] = useState<number>(0);
    const [ modalTags, setModalTags ] = useState<any>();
    const [ tag, setTag ] = useState<any>();
    const [ filteredTags, setFilteredTags ] = useState<any>();
    const [ selectedTags, setSelectedTags ] = useState<any>([]);
    const [ modalAprova, setModalAprova ] = useState<any>(false);
    const [ historyProposal, setHistoryProposal ] = useState<any>();
    const [ acceptProposal, setAcceptProposal ] = useState<any>();
    const [ refuseProposal, setRefuseProposal ] = useState<any>();
    const [ proposalTags, setProposalTags ] = useState<any[]>([]);
    const [ proposalFiles, setProposalFiles ] = useState<any[]>([]);
    const [ countieInfo, setCountieInfo ] = useState<any>({
        cidade: '',
        uf: '',
    });
    const [ modalPrice, setModalPrice ] = useState<any>(false);
    const [ newPercentage, setNewPercentage ] = useState<any>();
    const reader = new FileReader();

    const states = {
        control: (provided: Record<string, unknown>) => ({
            ...provided,
            height: 48,
            boxShadow: "none",
            cursor: 'pointer',
            // border: advancePageError?.uf ? '1px solid #FDB141' : '1px solid #EAEEF3',
            '&:hover': {
                border: `1px solid ${comum.colors.interfaceTextGray}`,
            },
        }),
        placeholder: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c353a40)',
            fontSize: '16px',
            fontWeight: '400',
        }),
        singleValue: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c353a40)',
            fontSize: '16px',
        }),
        option: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c5a646e)',
            fontSize: '16px',
            fontWeight: '500',
        }),
    }

    const city = {
        control: (provided: Record<string, unknown>) => ({
            ...provided,
            height: 48,
            boxShadow: "none",
            cursor: 'pointer',
            // border: advancePageError?.id_comarca ? '1px solid #FDB141' : '1px solid #EAEEF3',
            '&:hover': {
                border: `1px solid ${comum.colors.interfaceTextGray}`,
            },
        }),
        placeholder: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c353a40)',
            fontSize: '16px',
            fontWeight: '400',
        }),
        singleValue: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c353a40)',
            fontSize: '16px',
        }),
        option: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c5a646e)',
            fontSize: '16px',
            fontWeight: '500',
        }),
    }

    const modalities = {
        control: (provided: Record<string, unknown>) => ({
            ...provided,
            height: 48,
            boxShadow: "none",
            cursor: 'pointer',
            // border: advancePageError?.modalidade ? '1px solid #FDB141' : '1px solid #EAEEF3',
            '&:hover': {
                border: `1px solid ${comum.colors.interfaceTextGray}`,
            },
        }),
        placeholder: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c353a40)',
            fontSize: '16px',
            fontWeight: '400',
        }),
        singleValue: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c353a40)',
            fontSize: '16px',
        }),
        option: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c5a646e)',
            fontSize: '16px',
            fontWeight: '500',
        }),
    }

    async function carregaProfisisonal(id_user: any) {
            if(id_user) {
                const responseProfessional = await api.get('usuario/' + id_user);
                setProfessional(responseProfessional.data.result);

                if (responseProfessional.data.status !== 'success') {
                    throw new Error("Erro ao carregar profissional");
                }
            }
    }

    async function carregaSolicitante(id_solicitante: any) {
        if(id_solicitante) {
            const responseSolicitante = await api.get('escritorio/' + id_solicitante);
            setSelectedOffice(responseSolicitante.data.result[0]);

            if (responseSolicitante.data.status !== 'success') {
                throw new Error("Erro ao carregar escritório solicitante");
            }
        }
    }

    async function getProposal() {
        try {
            setLoading(true);
            const response = await api.get('proposta/' + proposalId);

            if(response.data.status === 'error') {
                throw new Error(response.data.message);
            }

            setProposalInitial(response.data.result);
            setDTOProposal(response.data.result);
            setProposalTags(response.data.result.tags);
            setProposalFiles(response.data.result.arquivos);
            setDateHearing(new Date(response.data.result.data));
            console.log("??")

            if (response.data.status !== 'success') {
                throw new Error();
            }

            const id_user = response.data.result.id_usuario
            await carregaProfisisonal(id_user);

            const id_solicitante = response.data.result.id_escritorio_solicitante
            await carregaSolicitante(id_solicitante);

            const responseHistory = await api.get('historico-proposta/' + proposalId);
            setHistoryProposal(responseHistory.data.result);
            console.log("???")

            if (responseHistory.data.status !== 'success') {
                throw new Error();
            }

            const countieId = response.data.result.id_comarca
            const responseCountie = await api.get('comarca/' + countieId)
            setCountieInfo(responseCountie.data.result);

            if (responseCountie.data.status !== 'success') {

                throw new Error(responseCountie.data.message)

            }
            console.log("?????")


            console.log(loading)
            setLoading(false);
            // setLoading(false);

        } catch (error: any) {

            toast.error(error.message || 'Erro ao buscar proposta', toastDefsError);

            setLoading(false);
        }

    }

    useEffect(() => {
        setPageName(`Proposta #${proposalId}`);

        setPageType('special')

        getProposal();

    }, [editProposal])

    function searchKeyPressed(event: any) {

        if (event.key === 'Enter') {
            // setSearchProfiles(DTOSearch)
        }

    }

    function clearSearch() {
        setDTOSearch('')
        // setSearchProfiles('')
    }

    async function duplicateProposal() {
        try {

            setLoading(true)

            const response = await api.delete('proposta-reaproveitar/'+ proposalId)

            if (response.data.status !== 'success') {

                throw new Error(response.data.result[0].message)

            } else {

                setDeleteProposal(false);
                history.push({
                    pathname: '/formulario-proposta',
                    state: {
                        name: 'Reuse',
                        proposal: response.data.result,
                    }
                })

            }


            setLoading(false);

        } catch (error: any) {

            toast.error(error.message || 'Erro ao buscar proposta', toastDefsError);
            setLoading(false);

        }
    }

    async function cancelProposal() {
        try {

            setLoading(true)

            if (justicationText === '') {
                throw new Error('Justifique sua decisão antes de cancelar a proposta')
            }

            clarity.setEvent('cancela-proposta')

            const justificativaEncoded = encodeURIComponent(justicationText);
            const response = await api.delete(`proposta/${proposalId}?justificativa=${justificativaEncoded}`)

            if (response.data.status !== 'success') {

                throw new Error(response.data.result[0].message)

            } else {

                history.push('/demandas');

                toast.success('Proposta cancelada.', toastDefs);



            }

            setDeleteProposal(false);
            setSecondStage(false);

            setLoading(false);

        } catch (error: any) {

            console.log('log do erro cancelando proposta', error.message)
            setLoading(false);

            toast.error(error.message || 'Erro ao cancelar proposta', toastDefsError);

        }
    }

    async function getCounties(selected: any) {

        try {
            setLoading(true);
            const response = await api.get(`comarca?uf=${selected.value}`)

            if (response.data.status !== 'success') {
                throw new Error();
            }
            const countieArray: { value: any, label: any }[] = []

            response.data.result.map((row: any) => (
                countieArray.push({
                    label: row.cidade,
                    value: row.id_comarca
                })
            ))

            setCounties(countieArray);
            setCountieInfo({
                cidade: '',
                uf: selected.value,
            })

            setLoading(false);

        } catch (error: any) {

            toast.error(error.message || 'Erro ao buscar comarcas', toastDefsError);
        }

    }

    function handleOnChangeMoney(name: string, value: string) {
        // O novo componente já retorna o valor no formato correto (XX.XX)
        const newDTO: any = DTOProposal
        newDTO[name] = value
        setDTOProposal({ ...newDTO })
    }

    function handleOnChange(name: any, value: any) {
        const newDTO: any = DTOProposal
        newDTO[name] = value
        setDTOProposal({ ...newDTO })
    }

    async function consultCep(name: any, value: any) {

        try {
            const cepLimpo = value.replace(/\D/g, '');

            if (cepLimpo.length !== 8) {
                return;
            }

            handleOnChange('cep', cepLimpo);
            const response = await axios.get(`https://viacep.com.br/ws/${cepLimpo}/json/`)
            const data = response.data

            if (data.erro) {
                toast.error('CEP não encontrado. Verifique o CEP digitado.', toastDefsError);
                return;
            }

            setCepCounty(data.bairro);
            setCepAddress(data.logradouro);

            handleOnChange('rua', data.logradouro || '');
            handleOnChange('bairro', data.bairro || '');

            if (!countieInfo?.uf || countieInfo.uf.trim() === '') {
                const estadoSelecionado = EstadosBrasileiros.find(estado => estado.value === data.uf);
                if (estadoSelecionado) {
                    await getCounties(estadoSelecionado);
                }
            }

        } catch (err: any) {

            console.error('Erro ao buscar CEP:', err);
            toast.error('Erro ao buscar CEP. Tente novamente.', toastDefsError);

        }

    }

    async function getTags() {
        try {

            if (tag && tag.length > MAX_TAG_LENGTH) {
                toast(<div className="warning"><span><IconWarning /></span> A TAG não pode ter mais de {MAX_TAG_LENGTH} caracteres!</div>,
                {
                    duration: 3000,
                    style: {
                        padding: '16px',
                        minWidth: '400px',
                        color: 'var(--c1a2858)',
                        background: 'var(--ce4f5ff)',
                        border: '2px solid #88D3FE',
                    },
                });  
                throw new Error(`TAG excede o limite de ${MAX_TAG_LENGTH} caracteres`)
            }

            if (!tag) {
                toast(<div className="warning"><span><IconWarning /></span> Digite uma TAG antes de pesquisar.</div>,
                    {
                        duration: 3000,
                        style: {
                            padding: '16px',
                            minWidth: '400px',
                            color: 'var(--c1a2858)',
                            background: 'var(--ce4f5ff)',
                            border: '2px solid #88D3FE',
                        },
                    });
                throw new Error('Digite uma TAG antes de pesquisar')
            }

            setLoading(true);

            const response = await api.get(`tag-find/${tag}?like=true`);
            setFilteredTags(response.data.result);

            if (response.data.status !== 'success') {
                throw new Error()
            }

            setLoading(false);

        } catch (error: any) {
            console.log('error log getting tags', error.message)
            setLoading(false);
        }

    }

    function searchTags(event: any) {

        if (event.key === 'Enter') {
            getTags()
        }
    }

    function handleTagInputChange(e: any) {
        const value = e.target.value;
        if (value.length <= MAX_TAG_LENGTH) {
            setTag(value);
        } else {
            toast(<div className="warning"><span><IconWarning /></span> A TAG não pode ter mais de {MAX_TAG_LENGTH} caracteres!</div>,
            {
                duration: 3000,
                style: {
                    padding: '16px',
                    minWidth: '400px',
                    color: 'var(--c1a2858)',
                    background: 'var(--ce4f5ff)',
                    border: '2px solid #88D3FE',
                },
            });
        }
    }

    function setNewTags(tag: any) {

        if (tag.length > MAX_TAG_LENGTH) {
            toast(<div className="warning"><span><IconWarning /></span> A TAG não pode ter mais de {MAX_TAG_LENGTH} caracteres!</div>,
            {
                duration: 3000,
                style: {
                    padding: '16px',
                    minWidth: '400px',
                    color: 'var(--c1a2858)',
                    background: 'var(--ce4f5ff)',
                    border: '2px solid #88D3FE',
                },
            });
            return;
        }

        setSelectedTags((selectedTags: any) => [...selectedTags, tag]);

        setTag('');
        setFilteredTags('');

        setProposalTags((proposalTags: any) => [...proposalTags, tag])

        setModalTags(false);
    }

    async function sendFiles(e: any) {
        try {
            const file = e.target.files[0];
            if (!file) return;

            // Validação de tamanho de arquivo (50MB)
            const MAX_FILE_BYTES = 50 * 1024 * 1024;
            if (file.size > MAX_FILE_BYTES) {
                toast.error(`Arquivo "${file.name}" excede 50MB.`, toastDefsError);
                e.target.value = '';
                return;
            }

            setLoading(true)

            const formData = new FormData();
            formData.append('arquivo', file);

            reader.addEventListener("load", () => {
            });

            reader.readAsDataURL(file);


            const response = await api.post(`fileupload?demandaId=${proposalInitial?.id_proposta}`, formData)

            setProposalFiles(proposalFiles => [...proposalFiles, {
                arquivo_final: "não",
                caminho: response.data.caminho
            }]);

            setLoading(false)

        } catch (error: any) {

            toast.error(error, toastDefsError);

        } finally {
            if (e.target) {
                e.target.value = '';
            }
        }
    }


    async function aprovaProposal() {

        setLoading(true);
        try {

            const response = await api.put(`proposta/${proposalId}/aprovar`);
            console.log('response', response);

            if (response.data.status !== 'success') {
                throw new Error(response.data.result[0].message);
            }

            setModalAprova(false);

            toast.success('Proposta aprovada com sucesso', toastDefs);
            window.setTimeout(() => {
                getProposal();
            }, 1000);

        } catch (error: any) {
            toast.error(error.message || 'Erro ao aprovar proposta', toastDefsError);
        } finally {
            setLoading(false);
        }
    }

    // Função para validar datas antes da atualização
    function validateDates(newFatalDate: string, newConclusionDate: string) {
        const errors: string[] = [];
        const now = moment();
        
        // Data de criação (usar a data original da proposta)
        const creationDate = moment(proposalInitial?.criado || proposalInitial?.data_inicio);
        
        // Validar Data Fatal
        if (newFatalDate) {
            const fatalDate = moment(newFatalDate);
            
            // Data Fatal não pode ser anterior à data de criação
            if (fatalDate.isBefore(creationDate)) {
                errors.push('Data Fatal não pode ser anterior à data de criação da proposta');
            }
            
            // Data Fatal não pode ser anterior à data atual (se não for uma alteração justificada)
            if (fatalDate.isBefore(now, 'day')) {
                errors.push('Data Fatal não pode ser anterior à data atual');
            }
        }
        
        // Validar Data de Conclusão
        if (newConclusionDate) {
            const conclusionDate = moment(newConclusionDate);
            
            // Data de conclusão não pode ser anterior à data de criação
            if (conclusionDate.isBefore(creationDate)) {
                errors.push('Data de conclusão não pode ser anterior à data de criação da proposta');
            }
            
            // Data de conclusão não pode ser anterior à Data Fatal
            if (newFatalDate && conclusionDate.isBefore(moment(newFatalDate))) {
                errors.push('Data de conclusão não pode ser anterior à Data Fatal');
            }
            
            // Data de conclusão não pode ser anterior à data atual
            if (conclusionDate.isBefore(now, 'day')) {
                errors.push('Data de conclusão não pode ser anterior à data atual');
            }
        }
        
        return errors;
    }

    async function updateProposal() {

        try {

            const newDate = moment(dateHearing).format("YYYY-MM-DD HH:mm:ss")
            const deadline = moment(DTOProposal.prazo_aceite).format("YYYY-MM-DD HH:mm:ss");
            const conclusionDate = moment(DTOProposal.prazo_para_conclusao).format("YYYY-MM-DD HH:mm:ss");

            // Validar datas antes de prosseguir
            const dateErrors = validateDates(newDate, conclusionDate);
            if (dateErrors.length > 0) {
                toast.error(dateErrors.join('; '));
                return;
            }

            const proposalUpdated = {
                id_usuario: DTOProposal.id_usuario,
                id_servico: DTOProposal.id_servico,
                id_comarca: DTOProposal.id_comarca,
                tags: proposalTags,
                arquivos: proposalFiles,
                numero_processo: DTOProposal.numero_processo,
                nome_cliente: DTOProposal.nome_cliente,
                valor_cliente: DTOProposal.valor_cliente,
                codigo_cliente: DTOProposal.codigo_cliente,
                prazo_aceite: deadline,
                prazo_para_conclusao: conclusionDate,
                dias_uteis_para_conclusao: DTOProposal.dias_uteis_para_conclusao,
                orientacoes: DTOProposal.orientacoes,
                tipo_audiencia: DTOProposal.tipo_audiencia,
                data: newDate,
                profissional_necessario: DTOProposal.profissional_necessario,
                modalidade: DTOProposal.modalidade,
                endereco_virtual: DTOProposal.endereco_virtual,
                rua: DTOProposal.rua,
                bairro: DTOProposal.bairro,
                cep: DTOProposal.cep,
                numero: DTOProposal.numero,
                complemento: DTOProposal.complemento,
                valor_profissional: DTOProposal.valor_profissional,
                tipo: proposalInitial.tipo,
            }

            clarity.setEvent('edita-proposta')

            const response = await api.put('proposta/' + proposalId, proposalUpdated)

            if (response.data.status !== 'success') {

                if (response.data.result[0] === undefined) {
                    throw new Error(response.data.message);

                } else {
                    throw new Error(response.data.result[0].message);
                }

            } else {
                setEditProposal(false);
                setModalPrice(false);

                toast.success('Alterações salvas com sucesso', toastDefs);
            }

        } catch (error: any) {

            console.log('log do erro', error.message)

            toast.error(error.message || 'Erro ao salvar proposta', toastDefsError);

        }
    }

    async function resolveProposal(value: boolean) {
        try {

            setLoading(true);

            const body = value ? {} : { justificativa: justicationText };

            const response = await api.put(`proposta-responder/${proposalId}?aceitar=${value}`, body);

            if (response.data.status !== 'success') {

                if (response.data.message === '1 Erros encontrados') {

                    throw new Error (response.data.result[0].message)

                } else {

                    throw new Error(response.data.message);
                }

            } else {

                setRefuseProposal(false);
                setAcceptProposal(false);
                setJustificationText(undefined);

                const mensagemSucesso = value ? 'Proposta aceita com sucesso' : 'Proposta recusada com sucesso';
                toast.success(mensagemSucesso, toastDefs);

                history.push('/demandas');

            }

        } catch (err: any) {
            console.log('log do erro resolve proposal', err.message)

            toast.error(err.message || 'Erro ao responder proposta', toastDefsError);

            if (err.message === 'É preciso uma assinatura PRO ou superior para responder as propostas') {
                setTimeout(() => {
                    history.push('/propostas')
                }, 3500)
            }
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {

        getPercentage();

    }, [DTOProposal.valor_cliente])

    function getPercentage() {
        const total = Number(DTOProposal.valor_cliente)
        const partial = DTOProposal.lucro

        setNewPercentage((100 * partial) / total);

    }

    useEffect(() => {
        const checkIfClickedOutside = (e: any) => {

            if (openHistory && historyRef.current && !historyRef.current.contains(e.target)) {
                setOpenHistory(false);
            }

            if (openMenu && menuRef.current && !menuRef.current.contains(e.target)) {
                setOpenMenu(false);
            }

        };

        document.addEventListener("mousedown", checkIfClickedOutside);

        return () => {
            document.removeEventListener("mousedown", checkIfClickedOutside);
        };
    }, [openHistory, openMenu]);

    function beforeCancelProposal() {

        if (justicationText === undefined) {

            toast.error('Justifique sua decisão antes de prosseguir.', toastDefsError);

        } else {

            setSecondStage(true);

        }

    };


    return (
        <Container>
            {
                loading &&
                <Oval
                    height={150}
                    width={150}
                    color={comum.colors.primaryRed400}
                    wrapperStyle={{}}
                    wrapperClass="loader"
                    visible={true}
                    ariaLabel='oval-loading'
                    secondaryColor={comum.colors.primaryRed400}
                    strokeWidth={2}
                    strokeWidthSecondary={2}
                />
            }

            {
                loading !== true &&
                <StatusHeader>
                    <Status>
                        {
                            proposalInitial?.status === 'Em Analise' &&
                            <p className="waiting"><IconStatus /> Aguardando aprovação</p>
                        }
                        {
                            proposalInitial?.status === 'Pendente' &&
                            <p className="waiting"><IconStatus /> Aguardando aceite</p>
                        }
                        {
                            proposalInitial?.status === 'Cancelada' &&
                            <p className="canceled"><IconStatus /> Cancelada por operador</p>
                        }
                        {
                            proposalInitial?.status === 'Recusada' &&
                            <p className="recused"><IconStatus /> Recusada pelo profissional</p>
                        }
                        {
                            proposalInitial?.status === 'Pendente' &&
                            <div className="type">
                                <IconClock color={comum.colors.primaryRed400}/>
                                <div>
                                    {proposalInitial?.prazo_aceite && moment(proposalInitial.prazo_aceite).isBefore(moment()) 
                                        ? 'Prazo de aceite expirado' 
                                        : proposalInitial?.prazo_aceite ? <><Moment locale='pt-br' fromNow ago>{proposalInitial.prazo_aceite}</Moment> restantes para o aceite</> : '-'
                                    }
                                </div>
                            </div>
                        }
                    </Status>

                    <Buttons>
                        {
                            user.profile === 'comum' && proposalInitial?.status === 'Pendente' &&
                            <>
                                <ButtonIcon
                                    styles="save"
                                    Icon={<IconAccept />}
                                    onClick={() => setAcceptProposal(true)}
                                >
                                    Aceitar
                                </ButtonIcon>
                                <ButtonIcon
                                    styles="reject"
                                    Icon={<IconClose color={comum.colors.primaryRed400}/>}
                                    onClick={() => setRefuseProposal(true)}
                                >
                                    Recusar
                                </ButtonIcon>
                            </>
                        }
                        {
                            editProposal !== true &&
                            (
                                user.profile !== 'comum' &&
                                user.profile !== 'Solicitante'
                            ) &&
                            <>
                            {
                                proposalInitial?.status === 'Cancelada' || proposalInitial?.status === 'Recusada'
                                ?   <ButtonIcon
                                        styles="save"
                                        Icon={<IconDuplicate />}
                                        onClick={() => duplicateProposal()}
                                        disabled={true}
                                    >
                                        Duplicar
                                    </ButtonIcon>
                                :   <ButtonIcon
                                        styles="save"
                                        Icon={<IconEdit />}
                                        onClick={() => setEditProposal(true)}
                                    >
                                        Editar
                                    </ButtonIcon>
                            }

                                <DropDownMenu
                                    onClick={() => { setOpenHistory(!openHistory); setOpenMenu(false) }}
                                    ref={historyRef}
                                >
                                    <IconTimer />
                                    <div
                                        className={openHistory ? 'hidden-history' : 'hidden-history no-show'}
                                    >
                                            <HistoryTitle>
                                                Histórico:
                                                <div
                                                    onClick={() => setOpenHistory(false)}
                                                >
                                                    <IconClose />
                                                </div>
                                            </HistoryTitle>

                                            <TimelineProposta historyProposal={historyProposal} />
                                    </div>
                                </DropDownMenu>


                                {
                                    proposalInitial?.status !== 'Cancelada' &&
                                    <DropDownMenu
                                        onClick={() => { setOpenMenu(!openMenu); setOpenHistory(false) }}
                                        ref={menuRef}
                                    >
                                        <div>
                                            <IconThreeDots />
                                        </div>
                                        <div
                                            className={openMenu ? 'hidden-menu' : 'hidden-menu no-show'}
                                        >
                                            {
                                                proposalInitial?.status === 'Pendente' ||
                                                proposalInitial?.status === 'Em Andamento' ||
                                                proposalInitial?.status === 'Em Analise'
                                                ?   <div
                                                        className="button"
                                                        onClick={() => setDeleteProposal(true)}
                                                    >
                                                        <IconClose color={comum.colors.primaryRed400}/>
                                                        Cancelar proposta
                                                    </div>
                                                :   <div
                                                        className="button"
                                                        onClick={() =>
                                                                toast.error("Proposta já cancelada", toastDefsError)
                                                        }
                                                    >
                                                        <IconClose color={comum.colors.primaryRed400}/>
                                                        Cancelar proposta
                                                    </div>
                                            }
                                            {
                                                proposalInitial?.status === 'Em Analise' &&
                                                <div
                                                    className="button"
                                                    onClick={() => setModalAprova(true)}
                                                >
                                                    <IconFinish /> 
                                                    Aprovar proposta
                                                </div>                                            
                                            }

                                        </div>
                                    </DropDownMenu>
                                }
                            </>
                        }
                        {
                            editProposal === true && user.profile !== 'comum' &&
                            <>
                                <ButtonDefault
                                    className="cancel"
                                    onClick={() => setEditProposal(false)}
                                >
                                    Cancelar
                                </ButtonDefault>

                                       <ButtonIcon
                                            styles="filter"
                                            Icon={<IconFloppyDisk />}
                                            onClick={() => updateProposal()}
                                        >
                                            Salvar Alterações
                                        </ButtonIcon>

                            </>

                        }
                    </Buttons>
                </StatusHeader>
            }

            {
                loading !== true &&
                <ProposalDetails>

                    <ProposalLeft>

                        {
                            editProposal !== true &&
                            <>
                                <BlocoEnderecoProposta
                                    dadoInicial={proposalInitial}
                                    infoComarca={countieInfo}
                                />

                                <ServiceTags>
                                    <span>Detalhes do serviço:</span>
                                    <div className="tags">
                                        {
                                            proposalInitial?.tags.map((row: any) => (
                                                <div className="tag" key={row}>{row}</div>
                                            ))
                                        }
                                    </div>
                                </ServiceTags>


                            {
                                proposalInitial !== undefined && user.profile !== 'comum' &&
                                <BlocoPendencias
                                    proposta={proposalInitial}
                                    setUpdate={() => {}}
                                    novaPendenciaPagamento={false}
                                    setNovaPendenciaPagamento={() => {}}
                                    profissional={professional}
                                    arquivos={[]}
                                    enviarArquivos={() => {}}
                                    solicitante={true}
                                />
                                    }

                                <Orientations>
                                    <span>Orientações:</span>
                                    {
                                        proposalInitial?.orientacoes.length === 0
                                            ?
                                                <div className="info">
                                                    Sem orientações iniciais.
                                                </div>
                                            :   <div className="info">{proposalInitial?.orientacoes}</div>
                                    }
                                </Orientations>

                                <Files>
                                    <span>Arquivos:</span>
                                    {
                                        (!proposalInitial?.arquivos || proposalInitial.arquivos.length === 0) &&
                                        <div className="file">Sem arquivos anexados</div>
                                    }
                                    {
                                        proposalInitial?.arquivos && proposalInitial.arquivos.length >= 1 &&
                                        proposalInitial.arquivos.map((row: any) => (
                                            <div className="file" key={row}>
                                                <div className="file-details">
                                                    <div className="icon-title">
                                                        <IconFile />
                                                        {(() => {
                                                            const parts = (row.caminho || '').split('/').filter(Boolean)
                                                            return parts[parts.length - 1] || row.caminho
                                                        })()}
                                                    </div>
                                                    <div className="date"><Moment locale='pt-br' format="DD/MM/YYYY">{proposalInitial?.criado}</Moment></div>
                                                </div>
                                                <div className="download">
                                                    <a 
                                                        href={`${baseURL}/getfile/${encodeFilePath(normalizeFilePath(row.caminho, proposalInitial?.id_proposta))}`} 
                                                        target="_blank" 
                                                        rel="noreferrer"
                                                        onClick={async (e) => {
                                                            try {
                                                                const normalizedPath = normalizeFilePath(row.caminho, proposalInitial?.id_proposta);
                                                                const url = `${baseURL}/getfile/${encodeFilePath(normalizedPath)}`;
                                                                const response = await fetch(url);
                                                                if (!response.ok) {
                                                                    e.preventDefault();
                                                                    if (response.status === 404) {
                                                                        toast.error('Arquivo não encontrado. O arquivo pode ter sido removido ou movido. Entre em contato com o suporte se o problema persistir.', toastDefsError);
                                                                    } else {
                                                                        toast.error('Erro ao baixar o arquivo. Por favor, tente novamente mais tarde.', toastDefsError);
                                                                    }
                                                                }
                                                            } catch (error) {
                                                                e.preventDefault();
                                                                toast.error('Erro ao baixar o arquivo. Por favor, verifique sua conexão e tente novamente.', toastDefsError);
                                                            }
                                                        }}
                                                    >
                                                        <IconDownload />
                                                    </a>
                                                </div>
                                            </div>
                                        ))
                                    }


                                </Files>
                            </>
                        }

                        {
                            editProposal === true &&
                            <>
                                <ProposalAdress>
                                    <div className="title-service">
                                        {
                                            proposalInitial?.descricao_categoria_servico.split(' ')[0] === 'Audiências' ? 'Audiência' : '' ||
                                            proposalInitial?.descricao_categoria_servico.split(' ')[0] === 'Diligências' ? 'Diligência' : '' ||
                                            proposalInitial?.descricao_categoria_servico.split(' ')[0] === 'Protocolos' ? 'Protocolo' : '' ||
                                            proposalInitial?.descricao_categoria_servico.split(' ')[0] === 'Outros' ? 'Outros' : ''
                                        } {proposalInitial?.titulo_servico.split(' ')[0]}
                                    </div>

                                    <div className="line">
                                        <div className="label-state">
                                            <p>Estado:</p>
                                            <Select
                                                name="estados"
                                                styles={states}
                                                components={{
                                                    IndicatorSeparator: () => null
                                                }}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 8,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: comum.colors.interfacePure100,
                                                        primary50: comum.colors.interfacePure100,
                                                        primary: comum.colors.interfacePure100,
                                                    },
                                                })}
                                                placeholder='Selecionar'
                                                defaultValue={{ value: countieInfo?.uf, label: countieInfo?.uf }}
                                                onChange={getCounties}
                                                options={EstadosBrasileiros}
                                            />
                                            {/* <span className="error">{advancePageError?.uf ? '*' : ''}</span> */}
                                        </div>

                                        <div className="label-state">
                                            <p>Comarca:</p>
                                            <Select
                                                styles={city}
                                                components={{
                                                    IndicatorSeparator: () => null
                                                }}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 8,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: comum.colors.interfacePure100,
                                                        primary50: comum.colors.interfacePure100,
                                                        primary: comum.colors.interfacePure100,
                                                    },
                                                })}
                                                name='id_comarca'
                                                placeholder="Selecionar"
                                                defaultValue={{ value: countieInfo?.cidade, label: countieInfo?.cidade }}
                                                options={counties}
                                                onChange={(e: any) => handleOnChange('id_comarca', e.value)}
                                            />
                                        </div>
                                    </div>

                                    <div className="line">
                                        <InputDefault
                                            title="Número do processo:"
                                            name="numero_processo"
                                            value={DTOProposal?.numero_processo}
                                            mask={'9999999-99.9999.9.99.9999'}
                                            onChangeText={(value) => handleOnChange('numero_processo', value)}
                                            className={proposalInitial?.numero_processo !== DTOProposal?.numero_processo ? 'mid highlight' : 'mid'}
                                        />

                                        <div className="label-state">
                                            <p>Subtipo:</p>
                                            {
                                                proposalInitial?.titulo_servico.split(' ')[0] === "Cível" &&
                                                <>
                                                    <Select
                                                        name="tipo_audiencia"
                                                        styles={states}
                                                        components={{
                                                            IndicatorSeparator: () => null
                                                        }}
                                                        theme={(theme) => ({
                                                            ...theme,
                                                            borderRadius: 8,
                                                            colors: {
                                                                ...theme.colors,
                                                                primary25: comum.colors.interfacePure100,
                                                                primary50: comum.colors.interfacePure100,
                                                                primary: comum.colors.interfacePure100,
                                                            },
                                                        })}
                                                        placeholder='Selecionar'
                                                        defaultValue={DTOProposal?.tipo_audiencia !== '' ? { value: DTOProposal.tipo_audiencia, label: DTOProposal.tipo_audiencia } : ''}
                                                        onChange={(selected: any) => handleOnChange('tipo_audiencia', selected.value)}
                                                        options={CivilHearing}
                                                    />
                                                </>
                                            }
                                            {
                                                proposalInitial?.titulo_servico.split(' ')[0] === "Penal" &&
                                                <>
                                                    <Select
                                                        name="tipo_audiencia"
                                                        styles={states}
                                                        components={{
                                                            IndicatorSeparator: () => null
                                                        }}
                                                        theme={(theme) => ({
                                                            ...theme,
                                                            borderRadius: 8,
                                                            colors: {
                                                                ...theme.colors,
                                                                primary25: comum.colors.interfacePure100,
                                                                primary50: comum.colors.interfacePure100,
                                                                primary: comum.colors.interfacePure100,
                                                            },
                                                        })}
                                                        placeholder='Selecionar'
                                                        defaultValue={DTOProposal.tipo_audiencia !== '' ? { value: DTOProposal.tipo_audiencia, label: DTOProposal.tipo_audiencia } : ''}
                                                        onChange={(selected: any) => handleOnChange('tipo_audiencia', selected.value)}
                                                        options={CriminalHearing}
                                                    />
                                                </>
                                            }
                                            {
                                                proposalInitial?.titulo_servico.split(' ')[0] === "Trabalhista" &&
                                                <>
                                                    <Select
                                                        name="tipo_audiencia"
                                                        styles={states}
                                                        components={{
                                                            IndicatorSeparator: () => null
                                                        }}
                                                        theme={(theme) => ({
                                                            ...theme,
                                                            borderRadius: 8,
                                                            colors: {
                                                                ...theme.colors,
                                                                primary25: comum.colors.interfacePure100,
                                                                primary50: comum.colors.interfacePure100,
                                                                primary: comum.colors.interfacePure100,
                                                            },
                                                        })}
                                                        placeholder='Selecionar'
                                                        defaultValue={DTOProposal.tipo_audiencia !== '' ? { value: DTOProposal.tipo_audiencia, label: DTOProposal.tipo_audiencia } : ''}
                                                        onChange={(selected: any) => handleOnChange('tipo_audiencia', selected.value)}
                                                        options={LaborHearing}
                                                    />
                                                </>
                                            }

                                        </div>
                                    </div>

                                    {
                                        proposalInitial?.descricao_categoria_servico === 'Audiências' &&
                                        <div className="line">
                                            <div className="label-state">
                                                <p>Modalidade:</p>
                                                <Select
                                                    name="modalidade"
                                                    styles={modalities}
                                                    components={{
                                                        IndicatorSeparator: () => null
                                                    }}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 8,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: comum.colors.interfacePure100,
                                                            primary50: comum.colors.interfacePure100,
                                                            primary: comum.colors.interfacePure100,
                                                        },
                                                    })}
                                                    placeholder='Selecionar'
                                                    defaultValue={DTOProposal?.modalidade !== '' ? { value: DTOProposal.modalidade, label: DTOProposal.modalidade } : ''}
                                                    onChange={(selected: any) => handleOnChange('modalidade', selected.value)}
                                                    options={ModalityAudience}
                                                />
                                                {/* <span className="error">{advancePageError?.modalidade ? '*' : ''}</span> */}
                                            </div>

                                            <div className="label-state">
                                                <p>Profissional necessário:</p>
                                                <Select
                                                    name="profissional_necessario"
                                                    styles={states}
                                                    components={{
                                                        IndicatorSeparator: () => null
                                                    }}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 8,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: comum.colors.interfacePure100,
                                                            primary50: comum.colors.interfacePure100,
                                                            primary: comum.colors.interfacePure100,
                                                        },
                                                    })}
                                                    placeholder='Selecionar'
                                                    defaultValue={DTOProposal?.profissional_necessario !== '' ? { value: DTOProposal.profissional_necessario, label: DTOProposal.profissional_necessario } : ''}
                                                    onChange={(selected: any) => handleOnChange('profissional_necessario', selected.value)}
                                                    options={ProfessionalTypeNecessary}
                                                />
                                                {/* <span className="error">{advancePageError?.profissional_necessario ? '*' : ''}</span> */}
                                            </div>
                                        </div>
                                    }

                                    <div className="line">
                                        <div className="label-state">
                                            <p>Prazo Fatal:</p>
                                            {
                                                proposalInitial?.data !== null
                                                ?   <DateTimePicker
                                                        key={datePickerKey}
                                                        onChange={(date) => {
                                                            // Validação imediata da Data Fatal
                                                            const now = moment();
                                                            const creationDate = moment(proposalInitial?.criado || proposalInitial?.data_inicio);
                                                            const conclusionDate = moment(DTOProposal.prazo_para_conclusao);
                                                            
                                                            if (moment(date).isBefore(creationDate)) {
                                                                toast.error('Data Fatal não pode ser anterior à data de criação da proposta');
                                                                // Força re-renderização para voltar ao valor anterior
                                                                setDatePickerKey(prev => prev + 1);
                                                                return;
                                                            }
                                                            
                                                            if (moment(date).isBefore(now, 'day')) {
                                                                toast.error('Data Fatal não pode ser anterior à data atual');
                                                                // Força re-renderização para voltar ao valor anterior
                                                                setDatePickerKey(prev => prev + 1);
                                                                return;
                                                            }
                                                            
                                                            // Validação: Data Fatal não pode ser posterior à Data de Conclusão
                                                            if (DTOProposal.prazo_para_conclusao && moment(date).isAfter(conclusionDate)) {
                                                                toast.error('Data Fatal não pode ser posterior à Data de Conclusão');
                                                                // Força re-renderização para voltar ao valor anterior
                                                                setDatePickerKey(prev => prev + 1);
                                                                return;
                                                            }
                                                            
                                                            // Só atualiza se passou em todas as validações
                                                            setDateHearing(date);
                                                        }}
                                                        // value={moment(proposalInitial?.data).add(3, 'hours').toDate()}
                                                        value={dateHearing}
                                                        calendarIcon={null}
                                                        disableClock={true}
                                                        className='date'
                                                        name="data"
                                                        required={true}
                                                    />
                                                :   <div className="no-data">Sem data</div>

                                            }
                                        </div>

                                        {
                                            proposalInitial?.modalidade === 'online' &&
                                            <InputDefault
                                                title="Endereço virtual:"
                                                name="link"
                                                value={DTOProposal?.endereco_virtual}
                                                onChangeText={(value) => handleOnChange('endereco_virtual', value)}
                                                className={proposalInitial?.endereco_virtual !== DTOProposal?.endereco_virtual ? 'big highlight' : 'big'}
                                            />
                                        }

                                        {
                                            proposalInitial?.modalidade !== 'online' &&
                                            <InputDefault
                                                title="CEP:"
                                                name="cep"
                                                mask="99999-999"
                                                value={DTOProposal.cep}
                                                onChangeText={(value) => consultCep('cep', value)}
                                                className={proposalInitial?.cep !== DTOProposal?.cep ? 'mid highlight' : 'mid'}
                                            />
                                        }
                                    </div>
                                    {
                                        proposalInitial?.modalidade !== 'online' &&
                                        <>
                                            <div className="line">
                                                <InputDefault
                                                    title="Rua:"
                                                    name="rua"
                                                    value={DTOProposal?.rua}
                                                    disabled={cepAddress ? true : false}
                                                    onChangeText={(value) => handleOnChange('rua', value)}
                                                    className={proposalInitial?.rua !== DTOProposal?.rua ? 'mid highlight' : 'mid'}
                                                />
                                                <InputDefault
                                                    title="Número:"
                                                    name="numero"
                                                    value={DTOProposal?.numero}
                                                    onChangeText={(value) => handleOnChange('numero', value)}
                                                    className={proposalInitial?.numero !== DTOProposal?.numero ? 'mid highlight' : 'mid'}
                                                />
                                            </div>

                                            <div className="line">
                                                <InputDefault
                                                    title="Bairro:"
                                                    name="bairro"
                                                    value={DTOProposal?.bairro}
                                                    disabled={cepCounty ? true : false}
                                                    onChangeText={(value) => handleOnChange('bairro', value)}
                                                    className={proposalInitial?.bairro !== DTOProposal?.bairro ? 'mid highlight' : 'mid'}
                                                />
                                                <InputDefault
                                                    title="Complemento:"
                                                    name="complemento"
                                                    value={DTOProposal?.complemento}
                                                    onChangeText={(value) => handleOnChange('complemento', value)}
                                                    className={proposalInitial.complemento !== DTOProposal?.complemento ? 'mid highlight' : 'mid'}
                                                />
                                            </div>
                                        </>
                                    }


                                </ProposalAdress>

                                <ServiceTags>
                                    <span>Detalhes do serviço:</span>
                                    <div className="tags">
                                        {
                                            proposalTags?.map((row: any) => (
                                                <div className={proposalInitial?.tags.includes(row) ? 'tag' : 'tag highlight'} key={row}>
                                                    {row}
                                                    <div
                                                        onClick={() => setProposalTags(proposalTags.filter((obj: any) => obj !== row))}
                                                        className='close'
                                                    >
                                                        <IconClose />
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                    <div
                                        className="add"
                                        onClick={() => setModalTags(!modalTags)}
                                    >
                                        <IconPlus /> Adicionar detalhes
                                    </div>
                                </ServiceTags>

                                <Orientations>
                                    <span>Orientações:</span>
                                    <div
                                        className="text"
                                    >
                                        <textarea
                                            name=""
                                            id=""
                                            defaultValue={DTOProposal.orientacoes}
                                            className={proposalInitial.orientacoes[0] !== DTOProposal.orientacoes ? 'text-area highlight' : "text-area"}
                                            onBlur={(e) => handleOnChange('orientacoes', e.target.value)}
                                        />
                                    </div>
                                </Orientations>

                                <Files>
                                    <span>Arquivos:</span>
                                    {
                                        (!proposalFiles || proposalFiles.length === 0) &&
                                        <div className="file">Sem arquivos anexados</div>
                                    }
                                    {
                                        proposalFiles && proposalFiles.length > 0 &&
                                        proposalFiles.map((row: any) => (
                                            <div className="file" key={row}>
                                                <div className={proposalInitial.arquivos.includes(row) ? "file-details" : 'file-details highlight'}>
                                                    <div className="icon-title">
                                                        <IconFile />
                                                        {(() => {
                                                            const parts = (row.caminho || '').split('/').filter(Boolean)
                                                            return parts[parts.length - 1] || row.caminho
                                                        })()}
                                                    </div>
                                                    <div className="date-trash">
                                                        <div className="date"><Moment locale='pt-br' format="DD/MM/YYYY">{proposalInitial?.criado}</Moment></div>
                                                        <div
                                                            className="icon-trash"
                                                            onClick={() => setProposalFiles(proposalFiles.filter((obj: any) => obj !== row))}
                                                        >
                                                            <IconTrash />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="download">
                                                    <a 
                                                        href={`${baseURL}/getfile/${encodeFilePath(normalizeFilePath(row.caminho, proposalInitial?.id_proposta))}`} 
                                                        target="_blank" 
                                                        rel="noreferrer"
                                                        onClick={async (e) => {
                                                            try {
                                                                const normalizedPath = normalizeFilePath(row.caminho, proposalInitial?.id_proposta);
                                                                const url = `${baseURL}/getfile/${encodeFilePath(normalizedPath)}`;
                                                                const response = await fetch(url);
                                                                if (!response.ok) {
                                                                    e.preventDefault();
                                                                    if (response.status === 404) {
                                                                        toast.error('Arquivo não encontrado. O arquivo pode ter sido removido ou movido. Entre em contato com o suporte se o problema persistir.', toastDefsError);
                                                                    } else {
                                                                        toast.error('Erro ao baixar o arquivo. Por favor, tente novamente mais tarde.', toastDefsError);
                                                                    }
                                                                }
                                                            } catch (error) {
                                                                e.preventDefault();
                                                                toast.error('Erro ao baixar o arquivo. Por favor, verifique sua conexão e tente novamente.', toastDefsError);
                                                            }
                                                        }}
                                                    >
                                                        <IconDownload />
                                                    </a>
                                                </div>
                                            </div>
                                        ))
                                    }
                                    <div
                                        className="add"
                                        onClick={() => ('')}
                                    >
                                        <IconUpload />
                                        <input
                                            type="file"
                                            name="Files"
                                            // accept="image/*"
                                            className="file-input"
                                            onChange={sendFiles}
                                        />

                                    </div>
                                </Files>
                            </>
                        }

                    </ProposalLeft>


                    <ProposalInfos>

                        {
                            ( user.profile !== 'comum' && user.profile !== 'Solicitante') &&
                            <>
                                <ServiceValue>
                                    <span>Valor do Cliente:</span>
                                    {
                                        editProposal !== true &&
                                        <div className="value-profit">
                                            <div className="icon"><IconServiceValue /></div>
                                            {
                                                proposalInitial?.valor_cliente !== null
                                                    ? <div className="value">R$ {Number(proposalInitial?.valor_cliente).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                                                    : <div className="value">R$ 0,00</div>
                                            }
                                        </div>
                                    }
                                    {
                                        editProposal === true &&
                                        <InputMoney
                                            name="valor_cliente"
                                            placeholder="R$ 0,00"
                                            value={DTOProposal.valor_cliente}
                                            onChangeText={(value: string) => handleOnChangeMoney('valor_cliente', value)}
                                            className='money'
                                        />
                                    }
                                </ServiceValue>
                            </>
                        }
                        {
                            user.profile !== 'Solicitante' &&
                            <ServiceValue>
                                <span>Valor do Profissional:</span>
                                {
                                    editProposal !== true &&
                                    <div className="value-profit">
                                        <div className="icon"><IconServiceValue /></div>
                                        {
                                            proposalInitial?.valor_profissional !== null
                                            ? <div className="value">R$ {Number(proposalInitial?.valor_profissional).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                                            : <div className="value">R$ 0,00</div>
                                        }
                                        {
                                            user.profile !== 'comum'
                                            ? proposalInitial?.lucro_porcentagem.includes('-')
                                                ? <div className="profit negative">{isNaN(Number(proposalInitial?.lucro_porcentagem)) ? '0' : proposalInitial?.lucro_porcentagem.split('.')[0]}% de lucro</div>
                                                : <div className="profit">+{isNaN(Number(proposalInitial?.lucro_porcentagem)) ? '0' : proposalInitial?.lucro_porcentagem.split('.')[0]}% de lucro</div>
                                            : ''
                                        }

                                    </div>
                                }
                                {
                                    editProposal === true &&
                                    <InputMoney
                                        name="valor_profissional"
                                        placeholder="R$ 0,00"
                                        value={DTOProposal.valor_profissional}
                                        onChangeText={(value: string) => handleOnChangeMoney('valor_profissional', value)}
                                        className='money'
                                    />
                                }
                            </ServiceValue>
                        }

                        {
                            user.profile !== 'comum' &&
                            <>
                            {
                                user.profile !== 'Solicitante' &&
                                <ServiceValue>
                                    <span>Cliente:</span>
                                    <div className="value-profit">
                                        <div className="icon"><IconUser /></div>
                                        <div className="value">{DTOProposal?.nome_cliente ? DTOProposal.nome_cliente.split(' ')[0] : 'N/A'}</div>
                                        <div className="code">
                                            {
                                                proposalInitial?.codigo_cliente
                                                ? proposalInitial?.codigo_cliente.includes('C')
                                                    ? proposalInitial?.codigo_cliente
                                                    : `C${proposalInitial?.codigo_cliente.replace('c', '')}`
                                                : 'N/A'
                                            }
                                        </div>
                                    </div>
                                </ServiceValue>
                            }

                                <ServiceValue className="office-selector-section">
                                    <span>Solicitante:</span>
                                    {!selectedOffice ? (
                                        <OfficeSelector
                                            selectedOffice={selectedOffice}
                                            onSelectOffice={getProposal}
                                            id_proposta={proposalInitial?.id_proposta}
                                            className="office-selector-edit"
                                        />
                                    ) : (
                                        <div className="value-profit">
                                            {selectedOffice ? (
                                                <>
                                        <div className="icon"><IconUser /></div>
                                                    <div className="value">{selectedOffice.nome}</div>
                                                    <div className="code">ES{selectedOffice.id_escritorio_solicitante}</div>
                                                    <div className="code-legacy">{selectedOffice.codigo ? `(${selectedOffice.codigo})` : ''}</div>
                                                </>
                                            ) : (
                                                <div className="value">Nenhum solicitante atribuído</div>
                                            )}
                                        </div>
                                    )}
                                </ServiceValue>

                                <ServiceValue>
                                    <span>Profissional:</span>
                                    {professional || user.profile === 'Solicitante' ? (
                                    <div className="value-profit">
                                        <div className="icon"><IconUser /></div>
                                            <div className="value">{professional?.nome ? professional?.nome.split(' ')[0].toLowerCase() : 'N/A' }</div>
                                        <div className="code">{professional?.id_usuario ? `D${professional.id_usuario}` : ''}</div>
                                        {professional && (
                                            <div
                                                className="button"
                                                onClick={() => setModalContact(true)}
                                            >
                                                <IconThreeDotsH />
                                            </div>
                                        )}
                                    </div>
                                    ) : (
                                        <ProfessionalSelector
                                            id_proposta={proposalInitial?.id_proposta}
                                            selectedProfessional={professional}
                                            onSelectProfessional={getProposal}
                                            className="professional-selector-edit"
                                        />
                                    )}
                                </ServiceValue>
                            </>
                        }

                        {
                            user.profile === 'comum' &&
                            <ServiceValue>
                                <span>Operador responsável:</span>
                                <div className="value-profit">
                                    <div className="icon"><IconUser /></div>
                                    <div className="value">{proposalInitial?.nomeOperador.split(' ')[0]}</div>
                                    <div className="code">P{proposalInitial?.id_operador}</div>
                                    {/* <div
                                        className="button"
                                        onClick={() => setModalContact(true)}
                                    >
                                        <IconThreeDotsH />
                                    </div> */}
                                </div>
                            </ServiceValue>
                        }

                        <DeadlineInfos>
                            <div className="deadline">
                                <span>Solicitada em:</span>
                                <div className="date-hour">
                                    <div className="info"><Moment locale='pt-br' format="DD/MM/YYYY">{proposalInitial?.criado}</Moment></div>
                                    <div className="info"><Moment  format="HH:mm">{proposalInitial?.criado}</Moment></div>
                                </div>
                            </div>
                            <div className="deadline">
                                <span>Prazo para aceite:</span>
                                <div className="date-hour">
                                    <div className="info"><Moment locale='pt-br' format="DD/MM/YYYY">{proposalInitial?.prazo_aceite}</Moment></div>
                                    <div className="info"><Moment  format="HH:mm">{proposalInitial?.prazo_aceite}</Moment></div>
                                </div>
                            </div>
                            <div className="deadline">
                                <span>Iniciada em:</span>
                                <div className="date-hour">
                                    <div className="info">
                                        {
                                            proposalInitial?.data_inicio
                                            ?   <Moment locale='pt-br' format="DD/MM/YYYY">{proposalInitial?.data_inicio}</Moment>
                                            :   'Aguardando'
                                        }
                                    </div>
                                    <div className="info">
                                        {
                                            proposalInitial?.data_inicio
                                            ?   <Moment  format="HH:mm">{proposalInitial?.data_inicio}</Moment>
                                            :   'aceite'
                                        }

                                    </div>
                                </div>
                            </div>
                            <div className="deadline">
                                <span>Prazo para conclusão:</span>
                                <div className="date-hour">
                                    <div className="info"><Moment locale='pt-br' format="DD/MM/YYYY">{proposalInitial?.prazo_para_conclusao}</Moment></div>
                                    <div className="info"><Moment  format="HH:mm">{proposalInitial?.prazo_para_conclusao}</Moment></div>
                                </div>
                            </div>
                        </DeadlineInfos>

                    </ProposalInfos>
                </ProposalDetails>
            }



            {/* Modal contatos do profissional */}
            <ModalDefault
                id={'overlayModal'}
                onClose={() => setModalContact((modalContact: any) => !modalContact)}
                openModal={modalContact}
                width="fit-content"
                maxWidth="98vw"
            >
                <ModalContactHead>
                    <div>
                        Entre em contato
                    </div>

                    <div
                        className="close"
                        onClick={() => setModalContact(false)}
                    >
                        <IconClose />
                    </div>
                </ModalContactHead>


                <ModalcontactMain>
                    <div>{professional?.email}</div>
                    <div>{professional?.celular
                        ? professional?.celular.replace(/\D/g, '')
                            .replace(/(\d{2})(\d)/, '($1) $2')
                            .replace(/(\d{5})(\d)/, '$1-$2')
                            .replace(/(-\d{4})\d+?$/, '$1')
                        : ''}
                    </div>
                    <div>{professional?.tel_fixo
                        ? professional.tel_fixo.replace(/\D/g, '')
                            .replace(/(\d{2})(\d)/, '($1) $2')
                            .replace(/(\d{4})(\d)/, '$1-$2')
                            .replace(/(-\d{4})\d+?$/, '$1')
                        : 'Telefone fixo não disponível'}
                    </div>
                    <div>{professional?.tel_recado
                        ? professional.tel_recado.replace(/\D/g, '')
                            .replace(/(\d{2})(\d)/, '($1) $2')
                            .replace(/(\d{4})(\d)/, '$1-$2')
                            .replace(/(-\d{4})\d+?$/, '$1')
                        : 'Telefone de recado não disponível'}
                    </div>
                </ModalcontactMain>
            </ModalDefault>

            {/* Modal cancelar proposta */}
            <ModalDefault
                id={'overlayModal'}
                onClose={() => setDeleteProposal((deleteProposal: any) => !deleteProposal)}
                openModal={deleteProposal}
                width="fit-content"
                maxWidth="98vw"
            >

                <ModalWrapper>
                    <ModalTitle>
                        <div className="points">
                            Deseja cancelar esta proposta?
                            <span>{secondStage ? <IconDeleteTwo /> : <IconDeleteOne />}</span>
                        </div>
                        <div
                            className="close"
                            onClick={() => setDeleteProposal(false)}
                        >
                            <IconClose />
                        </div>
                    </ModalTitle>

                    {
                        secondStage !== true &&
                        <div className="justify">
                            <p>Esta ação não pode ser desfeita.</p>
                            <span>Justifique sua decisão:</span>
                        </div>
                    }

                    {
                        secondStage === true &&
                        <div className="justify cancel">
                            <p>A proposta {proposalId} será cancelada.</p>
                            <span>Gostaria de reaproveitar as definições desta proposta na criação de uma nova?</span>
                        </div>
                    }


                    {
                        secondStage !== true &&
                        <ModalJustification>
                            <textarea
                                name="justify"
                                id="1"
                                className="text-area"
                                onChange={(e) => setJustificationText(e.target.value)}

                            />
                        </ModalJustification>
                    }

                    <ModalButtons>

                        {
                            secondStage
                            ?   <>
                                    <ButtonDefault
                                        className="cancel"
                                        onClick={cancelProposal}
                                    >
                                        Apenas cancelar
                                    </ButtonDefault>
                                    <ButtonDefault
                                        className="continue"
                                        onClick={duplicateProposal}
                                        disabled={true}
                                    >
                                        Apenas duplicar
                                    </ButtonDefault>
                                </>
                            :   <>
                                    <ButtonDefault
                                        className="cancel"
                                        onClick={() => setDeleteProposal(false)}
                                    >
                                        Voltar
                                    </ButtonDefault>
                                    <ButtonDefault
                                        className="continue"
                                        onClick={() => beforeCancelProposal()}
                                    >
                                        Continuar
                                    </ButtonDefault>
                                </>
                        }


                    </ModalButtons>

                </ModalWrapper>

            </ModalDefault>

            {/* Modal Tags */}
            <ModalDefault
                id={'overlayModal'}
                onClose={() => setModalTags((modalTags: any) => !modalTags)}
                openModal={modalTags}
                width="fit-content"
                maxWidth="98vw"
            >

                <ModalWrapper>
                    <ModalTitle>
                        <div className="points">
                            Adicionar detalhes
                        </div>
                        <div
                            className="close"
                            onClick={() => setModalTags(false)}
                        >
                            <IconClose />
                        </div>
                    </ModalTitle>

                    <ModalSearch>
                        <div className="title">Selecione ou crie tags para descrever o serviço:</div>

                        <div className="search">
                            <div
                                className="buscar"
                                onClick={() => getTags()}
                            >
                                <IconSearch />
                            </div>
                            <input
                                placeholder="Nome da tag"
                                onChange={handleTagInputChange}
                                onKeyPress={(e) => searchTags(e)}
                                value={tag}
                                maxLength={MAX_TAG_LENGTH}
                            />
                            {
                                filteredTags && !loading &&
                                <div
                                    className="clean-search"
                                    onClick={() => { setFilteredTags(''); setTag('') }}
                                >
                                    <IconClose />
                                </div>
                            }

                            <div className={filteredTags ? 'show-tags' : 'show-tags off'}>
                                {
                                    filteredTags?.length > 0
                                        ? <span>Selecione uma das tags:</span>
                                        : <span className="empty">0 tags encontradas para a sua pesquisa.</span>
                                }

                                <div className="tag-arrays">
                                    {
                                        filteredTags &&
                                        filteredTags.map((row: any) => (
                                            <div
                                                className="tag"
                                                onClick={() => setNewTags(row.tag)}
                                                key={row.id_tag}
                                            >
                                                {row.tag}
                                            </div>
                                        ))
                                    }
                                </div>

                                {
                                    filteredTags &&
                                        filteredTags?.find((obj: { tag: any; }) => obj.tag === tag)
                                        ? ''
                                        : <>
                                            <span className="span-no-tag">Crie uma nova tag para:</span>
                                            <div className="no-tags">
                                                <div
                                                    className="tag"
                                                    onClick={() => { setNewTags(tag); setTag(''); setFilteredTags(''); }}
                                                >
                                                    {tag}
                                                </div>
                                            </div>
                                        </>
                                }


                            </div>
                        </div>

                        <div className={`char-counter ${tag && tag.length > MAX_TAG_LENGTH * 0.9 ? 'warning' : ''}`}>
                            {tag ? tag.length : 0}/{MAX_TAG_LENGTH} caracteres
                        </div>
                    </ModalSearch>


                </ModalWrapper>

            </ModalDefault>

            {/* Modal para aceitar proposta*/}
            <ModalDefault
                id={'overlayModal'}
                onClose={() => setAcceptProposal((acceptProposal: any) => !acceptProposal)}
                openModal={acceptProposal}
                width="520px"
            >

                <ModalWrapper>
                    <ModalTitle>
                        {
                            secondStage
                            ?   <div className="points">
                                    Proposta aceita com sucesso!

                                </div>
                            :   <div className="points">
                                    Deseja aceitar esta proposta?
                                </div>
                        }
                        <div
                            className="close"
                            onClick={() => setAcceptProposal(false)}
                        >
                            <IconClose />
                        </div>
                    </ModalTitle>

                    {
                        !secondStage &&
                        <div className="accept">
                            <p>Ao aceitar, você concorda com as responsabilidades e condições descritas na proposta.</p>
                        </div>
                    }

                    {
                        secondStage &&
                        <div className="accept ">
                            <div>O prazo de conclusão para esta demanda encerra em <Moment locale='pt-br' fromNow ago>{proposalInitial?.prazo_para_conclusao}</Moment>, no dia <Moment locale='pt-br' format="DD/MM/YYYY">{proposalInitial?.prazo_para_conclusao}</Moment> às <Moment  format="HH:mm">{proposalInitial?.prazo_para_conclusao}</Moment>h.</div>
                            <span>Você pode acompanha-la pelo painel de demandas!</span>
                        </div>
                    }

                    <ModalButtons>

                        {
                            secondStage
                                ?   <>
                                        <ButtonDefault
                                            className="cancel"
                                            onClick={() => setSecondStage(false)}
                                        >
                                            Voltar
                                        </ButtonDefault>
                                        <ButtonDefault
                                            className="continue"
                                            onClick={() => resolveProposal(true)}
                                        >
                                            Abrir demanda
                                        </ButtonDefault>
                                    </>
                                :   <>
                                        <ButtonDefault
                                            className="cancel"
                                            onClick={() => setAcceptProposal(false)}
                                        >
                                            Cancelar
                                        </ButtonDefault>
                                        <ButtonDefault
                                            className="continue"
                                            onClick={() => setSecondStage(true)}
                                        >
                                            Aceitar
                                        </ButtonDefault>
                                    </>
                        }


                    </ModalButtons>

                </ModalWrapper>

            </ModalDefault>

            {/* Modal recusar proposta */}
            <ModalDefault
                id={'overlayModal'}
                onClose={() => setRefuseProposal((refuseProposal: any) => !refuseProposal)}
                openModal={refuseProposal}
                width="520px"
            >

                <ModalWrapper>
                    <ModalTitle>
                        <div className="points">
                            Deseja recusar esta proposta?
                        </div>
                        <div
                            className="close"
                            onClick={() => setRefuseProposal(false)}
                        >
                            <IconClose />
                        </div>
                    </ModalTitle>

                    <div className="refuse">
                        <p>Descreva a justificativa da exclusão:</p>
                    </div>

                    <ModalJustification>
                        <textarea
                            name="justify"
                            id="1"
                            className="text-area"
                            onChange={(e) => setJustificationText(e.target.value)}
                        />
                    </ModalJustification>


                    <ModalButtons>

                       <ButtonDefault
                            className="cancel"
                            onClick={() => setRefuseProposal(false)}
                        >
                            Cancelar
                        </ButtonDefault>
                        <ButtonDefault
                            className="continue"
                            disabled={justicationText === undefined ? true : false}
                            onClick={() => resolveProposal(false)}
                        >
                            Recusar
                        </ButtonDefault>

                    </ModalButtons>

                </ModalWrapper>

            </ModalDefault>

            {/* Modal salvar alterações preço */}
            <ModalDefault
                id={'overlayModal'}
                onClose={() => setModalPrice((modalPrice: any) => !modalPrice)}
                openModal={modalPrice}
                width="520px"
            >
                <ModalContactHead>
                    <div>
                        Salvar alterações
                    </div>

                    <div
                        className="close"
                        onClick={() => setModalPrice(false)}
                    >
                        <IconClose />
                    </div>
                </ModalContactHead>

                <ModalChanges>
                    <div className="adjust">
                        Com os ajustes realizados, o valor do serviço foi atualizado com base na precificação do profissional.
                    </div>

                    <div className="prices">
                        {
                            proposalInitial?.valor_cliente !== null
                            ? <div className="old-price">
                                <p>De:</p>
                                R$ {Number(proposalInitial?.valor_cliente).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                <div className="icon">
                                    <IconServiceValue />
                                </div>
                            </div>
                            : <div className="old-price">
                                <p>De:</p>
                                R$ 0,00
                                <div className="icon">
                                    <IconServiceValue />
                                </div>
                            </div>
                        }

                        {
                            DTOProposal?.valor_cliente !== null
                            ? <div className="new-price">
                                <p>Para:</p>
                                R$ {Number(DTOProposal?.valor_cliente).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                <div className="icon">
                                    <IconServiceValue />
                                </div>
                            </div>
                            : <div className="new-price">
                                <p>Para:</p>
                                R$ 0,00
                                <div className="icon">
                                    <IconServiceValue />
                                </div>
                            </div>
                        }

                    </div>

                    <div className="profit">O lucro estimado de <span>{isNaN(Number(proposalInitial?.lucro_porcentagem)) ? '0' : proposalInitial?.lucro_porcentagem.replace('.00', '')}</span> passa a ser de <span>{newPercentage?.toFixed()}%</span>, com base no valor pago pelo cliente.</div>
                </ModalChanges>


                <ModalButtons>

                    <ButtonDefault
                        className="cancel"
                        onClick={() => setModalPrice(false)}
                    >
                        Cancelar
                    </ButtonDefault>
                    <ButtonDefault
                        className="continue"
                        disabled={justicationText === undefined ? true : false}
                        onClick={() => updateProposal()}
                    >
                        Salvar alterações
                    </ButtonDefault>

                </ModalButtons>

            </ModalDefault>

            <ModalDefault
                id={'overlayModal'}
                onClose={() => setModalAprova((modalAprova: any) => !modalAprova)}
                openModal={modalAprova}
                width="520px"
            >
                <ModalContactHead>  
                    <div>
                        Aprovar proposta
                    </div>

                    <div
                        className="close"
                        onClick={() => setModalAprova(false)}
                    >
                        <IconClose />
                    </div>
                </ModalContactHead>
                <ModalChanges>
                    <div className="adjust">
                        Ao aprovar a proposta, ela será movida para a etapa de <span>Pendente</span> e poderá ser aceita ou recusada.
                    </div>
                </ModalChanges>
                <ModalButtons>
                    <ButtonDefault
                        className="cancel"
                        onClick={() => setModalAprova(false)}
                    >
                        Cancelar
                    </ButtonDefault>
                    <ButtonDefault
                        className="continue"
                        onClick={() => aprovaProposal()}
                    >
                        Aprovar
                    </ButtonDefault>
                </ModalButtons>
            </ModalDefault>

        </Container>
    )
}
